import { IFetchPatientAsyncAction, PatientActionTypes } from "./patientTypes"

export const fetchPatientAsync = (patientId: string): IFetchPatientAsyncAction => {
  return {
    type: PatientActionTypes.FETCH_PATIENT_ASYNC_PENDING,
    payload: patientId
  }
}
